import { render, staticRenderFns } from "./ZealStudentBulkICardPrint.vue?vue&type=template&id=4f1038fb&scoped=true&"
import script from "./ZealStudentBulkICardPrint.vue?vue&type=script&lang=js&"
export * from "./ZealStudentBulkICardPrint.vue?vue&type=script&lang=js&"
import style0 from "./ZealStudentBulkICardPrint.vue?vue&type=style&index=0&id=4f1038fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1038fb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
